import React from 'react';

import { Badge } from '@dashboard/components/ui/badge';
import { useBlockedEmails } from '@dashboard/hooks/useBlockedEmails';

const BlockedBadge = ({ email, className }) => {
  const { isBlocked } = useBlockedEmails();

  if (!email || !isBlocked(email)) return null;

  return (
    <Badge variant="destructive" className={className}>
      Blocked
    </Badge>
  );
};

export default BlockedBadge;
